import { navigateTop } from './embed';

const ACTIVE_KEY = 'tresor_customer_active';
const STATUS_CACHE_KEY = 'tresor_status_cache';

export function markTresorCustomerSession(statusData) {
  sessionStorage.setItem(ACTIVE_KEY, '1');
  if (statusData) {
    sessionStorage.setItem(STATUS_CACHE_KEY, JSON.stringify(statusData));
  }
}

export function clearTresorCustomerSession() {
  sessionStorage.removeItem(ACTIVE_KEY);
  sessionStorage.removeItem(STATUS_CACHE_KEY);
}

export function hadTresorCustomerSession() {
  return sessionStorage.getItem(ACTIVE_KEY) === '1';
}

export function getCachedTresorStatus() {
  try {
    const raw = sessionStorage.getItem(STATUS_CACHE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function getTresorLoginUrl() {
  try {
    if (sessionStorage.getItem('tresor_post_logout') === '1') {
      return 'https://datenputzer.de/login?return=tresor';
    }
  } catch (_) { /* ignore */ }
  return '/login';
}

export function redirectToDatenputzerLogin() {
  try {
    if (sessionStorage.getItem('tresor_post_logout') === '1') {
      navigateTop('https://datenputzer.de/login?return=tresor');
      return;
    }
  } catch (_) { /* ignore */ }
  navigateTop('https://datenputzer.de/sso?redirect=tresor');
}
